
import MedicalServices from "../../../../../components/modules/providers/provider-management/components/services-provided/MedicalServices";
import Navigation from "../../../../../components/navigations/provider-management/detail/location-info/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";

export default () => {
  const { id } = useParentLoaderData(2);

  return (
    <Navigation activeTab="services" providerId={id}>
      <MedicalServices/>
    </Navigation>
  );
};
